import styled from 'styled-components';

const Input = styled.input<{ max: string | number }>`
  width: 100%;
  gap: 0px;
  outline: none;

  color: ${({ theme }) => theme.white};
  background: none;
  &::placeholder {
    color: ${({ theme }) => theme.lightGray} !important;
  }
  font-size: 16px;
  border: none;

  /* Disable autofill background */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-background-clip: text;
    -webkit-text-fill-color: ${({ theme }) => theme.white};
    transition: background-color 5000s ease-in-out 0s;
    box-shadow: inset 0 0 20px 20px rgba(35, 35, 35, 0);
  }
  padding: 16px 32px;

  ::-ms-reveal,
  ::-ms-clear {
    display: none !important;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  /* height: 50px; */
  gap: 0px;
  outline: none;
  padding: 16px 32px;
  font-family: inherit;
  color: ${({ theme }) => theme.white};
  background: none;
  &::placeholder {
    color: ${({ theme }) => theme.lightGray} !important;
  }
  font-size: 16px;
  border: none;
  max-width: 100%;
  min-width: 100%;
  height: 100px;
  min-height: 100px;
  max-height: 200px;

  /* Disable autofill background */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-background-clip: text;
    -webkit-text-fill-color: ${({ theme }) => theme.white};
    transition: background-color 5000s ease-in-out 0s;
    box-shadow: inset 0 0 20px 20px rgba(35, 35, 35, 0);
  }

  ::-ms-reveal,
  ::-ms-clear {
    display: none !important;
  }
`;

const InputContainer = styled.div<{ padding: string }>`
  width: 100%;
  /* height: 50px; */
  gap: 0px;
  border-radius: 30px;
  outline: none;
  margin: 10px 0 15px 0;
  /* padding: 0 20px; */
  color: ${({ theme }) => theme.white};
  display: flex;
  &::placeholder {
    color: ${({ theme }) => theme.lightGray} !important;
  }
  font-size: 16px;
  background: ${({ theme }) => theme.darkGray};

  border: 1px solid ${({ theme }) => theme.primary};
  box-shadow: 0px 70.82px 130.86px 0px rgba(0, 0, 0, 0.1);
`;

const InpCont = styled.div<{ val: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  :focus-within {
    .lab {
      height: 12px;
      opacity: 0.7;
    }
  }
  ${({ val }) =>
    val
      ? ` .lab {
    height: 12px;
    opacity: 0.7;
  }`
      : ``};
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 400;
  line-height: 17.61px;
  color: #fff;
`;

export const InputComponent = (props: any) => {
  return (
    <>
      {props.label && <Label>{props.label}</Label>}
      <InputContainer style={props.style} padding={props.padding}>
        <InpCont val={props.value}>
          {props.type === 'textarea' ? (
            <Textarea {...props} />
          ) : (
            <Input {...props} />
          )}
        </InpCont>
      </InputContainer>
    </>
  );
};
